import { mapQuery } from 'utils/query';
import { useProfitAndLossesQuery } from 'store/api/event';
import { Details, EventProfitAndLosses } from 'components';

import { ProfitAndLossesProps } from './types';

export const ProfitAndLosses = ({ event }: ProfitAndLossesProps) => {
  const { data: profitAndLosses, ...props } = useProfitAndLossesQuery(
    String(event.id),
    { skip: !event.id }
  );

  return (
    <Details {...mapQuery(props)}>
      <EventProfitAndLosses event={event} profitAndLosses={profitAndLosses} />
    </Details>
  );
};
